import axios from 'axios';
import store from '../store/store.js'

export default class APIConnector {

        HTTP;
        //General
        connect() {
                this.HTTP = axios.create({
                        // baseURL: 'http://localhost/nutrivitasapp/api/v1/',
                        baseURL: 'https://nutrivitas.com/api/api/v1/',
                        headers: store.getters.apiToken != null ? {
                                Authorization: 'Bearer ' + store.getters.apiToken
                        } : null
                })
        }

        async getBrainTreeToken() {
                this.connect();
                return this.HTTP.get("me/payments/token");
        }

        async upgradeUser(payload) {
                this.connect();
                return this.HTTP.post("me/payments/submit", {
                        payload: payload
                });
        }

        //Login
        async login(email, password) {
                this.connect();
                store.commit('updateGlobalDate', new Date());
                return this.HTTP.post("login", {
                        email: email,
                        password: password
                });
        }

        async resetPassword(email) {
                this.connect();
                return this.HTTP.post("forgot-password/" + email);
        }


        async confirmAccount(confirmationCode) {
                this.connect();
                return this.HTTP.post("confirmaccount", {
                        confirmationCode: confirmationCode
                });
        }

        //Register
        register(name, email, password) {
                this.connect();
                return this.HTTP.post("register", {
                        name: name,
                        email: email,
                        password: password
                });
        }

        fbLogin(user) {
                this.connect();
                store.commit('updateGlobalDate', new Date());
                return this.HTTP.post("fblogin", {
                        user: user
                });
        }

        //Update User profile
        me(fn) {
                this.connect();
                this.HTTP.get('me').then(response => {
                        store.commit('updateUser', response.data.data);
                        eval(fn);
                }).catch(e => {
                        return false;
                });
        }

        getCustomIngredients() {
                this.connect();
                return this.HTTP.get('me/food/custom');
        }

        getWaterIntake(date) {
                this.connect();
                let url = date == null ? "me/water" : "me/water/" + date.formatMYSQL();
                return this.HTTP.get(url);
        }

        addWaterIntake(ml, date) {
                this.connect();
                return this.HTTP.post("me/water/track", {
                        number_of_milliliters: ml,
                        date: new Date(date).formatMYSQL()
                });
        }

        deleteWaterIntake(id) {
                this.connect();
                return this.HTTP.post('me/water/delete/' + id);
        }

        //Update Profile
        updateProfile(profile) {
                this.connect();
                return this.HTTP.post("me/update", {
                        profile: profile
                });
        }

        //Search Food
        searchFood(searchTerm, foodLabel, currentPage) {
                this.connect();
                if (searchTerm != null) {
                        return this.HTTP.get('search/ingredients?keyword=' + searchTerm + '&food_label=' + foodLabel + '&page=' + currentPage);
                } else {
                        return this.HTTP.get('search/ingredients?food_label=' + foodLabel + '&page=' + currentPage);
                }

        }

        //Search Recipe
        searchRecipes(searchTerm, recipeCategory, currentPage) {
                this.connect();
                if (searchTerm != null) {
                        return this.HTTP.get('search/recipes?keyword=' + searchTerm + '&category=' + recipeCategory + '&page=' + currentPage + '&page_size=12');
                } else {
                        return this.HTTP.get('search/recipes?category=' + recipeCategory + '&page=' + currentPage + '&page_size=12');
                }
        }

        //Track Food
        trackFood(mealTypeId, ingredientId, quantity, measurementData, date) {
                this.connect();
                return this.HTTP.post('me/food/track', {
                        meal_type_id: mealTypeId,
                        ingredient_id: ingredientId,
                        servings: quantity,
                        ingredient_measurement: measurementData,
                        date: new Date(date).formatMYSQL()
                });
        }

        getFoodLabels() {
                this.connect();
                return this.HTTP.get('foodlabels');
        }

        getRecipeCategories() {
                this.connect();
                return this.HTTP.get('recipecategories');
        }

        addCustomIngredient(newIngredient, newIngredientFoodLabels, newIngredientNutrients, photo, serving_description, serving_quantity, packaging_description, packaging_quantity, company, barcode) {
                let formData = new FormData();
                formData.append('new_ingredient', newIngredient);
                formData.append('new_ingredient_food_labels', newIngredientFoodLabels.toString().split(","));
                formData.append('new_ingredient_nutrients', newIngredientNutrients);
                formData.append('photo', photo);
                formData.append('serving_description', serving_description);
                formData.append('serving_quantity', serving_quantity);
                formData.append('manufacturer', serving_quantity);
                formData.append('packaging_quantity', packaging_quantity);
                formData.append('packaging_description', packaging_description);
                formData.append('company', company);
                formData.append('barcode', barcode);

                this.connect();
                this.headers = {
                        Authorization: 'Bearer ' + store.getters.apiToken,
                        'Content-Type': 'multipart/form-data'
                };
                return this.HTTP.post('me/food/create', formData);
        }

        trackRecipe(mealTypeId, recipeId, numberOfServings, date) {
                this.connect();
                return this.HTTP.post('me/food/track/recipe', {
                        meal_type_id: mealTypeId,
                        recipe_id: recipeId,
                        servings: numberOfServings,
                        date: new Date(date).formatMYSQL()
                });
        }

        getRecipeDetails(id) {
                this.connect();
                return this.HTTP.get('recipes/' + id);
        }

        //Get Food
        getFoodsByDate(date) {
                let d = new Date(Date.parse(date));

                this.connect();
                return this.HTTP.get('me/food/' + d.formatMYSQL());
        }

        getRecentIngredients() {
                this.connect();
                return this.HTTP.get('me/food/recent');
        }

        getFrequentIngredients() {
                this.connect();
                return this.HTTP.get('me/food/frequent');
        }

        getProgress(metric, date) {
                this.connect();
                let url = date == null ? "me/progress/" + metric : "me/progress/" + metric + "/" + date.formatMYSQL();
                if (metric == null) {
                        url = "me/progress";
                }
                return this.HTTP.get(url);
        }

        getProgressChart(metric) {
                this.connect();
                return this.HTTP.get("me/progress-chart/" + metric);
        }

        addProgress(metric, newWeightDate, newWeightValue, newWeightPhoto) {
                let formData = new FormData();
                formData.append('date', newWeightDate.formatMYSQL());
                formData.append('metric_type', metric);
                formData.append('value', newWeightValue);
                formData.append('photo', newWeightPhoto);

                this.connect();
                this.headers = {
                        Authorization: 'Bearer ' + store.getters.apiToken,
                        'Content-Type': 'multipart/form-data'
                };
                return this.HTTP.post('me/progress/track', formData);
        }

        addMeasurements(measurements, newMeasurementsDate, newMeasurementPhoto) {
                let formData = new FormData();
                formData.append('date', newMeasurementsDate.formatMYSQL());
                formData.append('measurements', JSON.stringify(measurements));
                formData.append('photo_url', newMeasurementPhoto);

                this.connect();
                this.headers = {
                        Authorization: 'Bearer ' + store.getters.apiToken,
                        'Content-Type': 'multipart/form-data'
                };

                return this.HTTP.post('me/progress/trackmeasurements', formData);
        }

        deleteProgress(id) {
                this.connect();
                return this.HTTP.post('me/progress/delete/' + id);
        }

        deleteMeasurements(date) {
                this.connect();
                return this.HTTP.post('me/progress/deletemeasurements/' + date);
        }

        getAvailableMealPlans() {
                this.connect();
                return this.HTTP.get('mealplans');
        }

        startMealPlan(mealPlanId, mealPlanDate) {
                this.connect();
                return this.HTTP.post('me/meal-plan/track', {
                        meal_plan_id: mealPlanId,
                        starting_date: mealPlanDate.formatMYSQL()
                });
        }

        deleteFoodTracking(foodTrackingId) {
                this.connect();
                return this.HTTP.post('me/food/delete/' + foodTrackingId);
        }

        getRecentExercises() {
                this.connect();
                return this.HTTP.get('me/personal-training/recent');
        }

        getExerciseSetHistory(id) {
                this.connect();
                return this.HTTP.get('me/personal-training/history/' + id);
        }

        getWorkoutExercises(id) {
                this.connect();
                return this.HTTP.get('me/exercise-plans/' + id);
        }

        getExercisesPlans() {
                this.connect();
                return this.HTTP.get('me/exercise-plans');
        }

        getExercises() {
                this.connect();
                return this.HTTP.get('exercises');
        }

        addPersonalTraining(data) {
                this.connect();
                return this.HTTP.post('me/personal-training/track', data);
        }

        addExercise(date, exerciseId, specificMotionId, duration) {
                this.connect();
                return this.HTTP.post('me/exercise/track', {
                        date: date,
                        activity_id: exerciseId,
                        activity_specific_motion_id: specificMotionId,
                        duration: duration
                });
        }

        getMyExercises(pageNumber) {
                this.connect();
                var pager = pageNumber == null ? "" : "?page=" + pageNumber;
                return this.HTTP.get('me/exercise/all' + pager);
        }

        getSpecificMotions(activity_id) {
                this.connect();
                return this.HTTP.get('exercises/' + activity_id);
        }

        getExercisesByDate(date) {
                this.connect();
                return this.HTTP.get('me/exercise/' + date);
        }

        deleteExercise(id) {
                this.connect();
                return this.HTTP.post('me/exercise/delete/' + id);
        }

        getShoppingList() {
                this.connect();
                return this.HTTP.get('me/shopping');
        }

        getShoppingMarkets() {
                this.connect();
                return this.HTTP.get('setting/shops');
        }

        sendShoppingEmail(item) {
                this.connect();
                return this.HTTP.post('me/shopping/send', {
                        "name": item.name,
                        "email": item.email,
                });
        }

        toggleShoppingListItem(item) {
                this.connect();
                return this.HTTP.post('me/shopping/toggle/' + item);
        }

        deleteShoppingListItem(item) {
                this.connect();
                return this.HTTP.post('me/shopping/delete/' + item);
        }

        getIngredientById(id) {
                this.connect();
                return this.HTTP.get('search/ingredients/' + id);
        }

        getRecipeById(id) {
                this.connect();
                return this.HTTP.get('search/recipes/' + id);
        }

        addFoodToShoppingList(ingredient, quantity, unit) {
                this.connect();
                return this.HTTP.post('me/shopping', {
                        ingredient_id: ingredient,
                        quantity: quantity,
                        unit: unit,
                });
        }

        addRecipeToShoppingList(recipe, servings) {
                this.connect();
                return this.HTTP.post('me/shopping/recipe', {
                        recipe_id: recipe,
                        servings: servings
                });
        }

        uploadPhoto(folder, file) {
                let formData = new FormData();
                formData.append('top_folder', folder);
                formData.append('photo', file);

                this.connect();
                this.headers = {
                        Authorization: 'Bearer ' + store.getters.apiToken,
                        'Content-Type': 'multipart/form-data'
                };

                return this.HTTP.post('me/photo', formData);
        }

        createCustomRecipe(recipe) {
                this.connect();

                let ingredients = [];
                for (var i = 0; i < recipe.ingredients.length; i++) {
                        let ingredient = new Object();
                        ingredient.id = recipe.ingredients[i].id;
                        ingredient.specified_qty = recipe.ingredients[i].quantity;
                        ingredient.specified_measurement = recipe.ingredients[i].selected_measurement;
                        ingredients.push(ingredient);
                }
                return this.HTTP.post('me/food/create/recipe', {
                        name: recipe.name,
                        description: recipe.description,
                        preparation_time: recipe.preparation_time,
                        cooking_time: recipe.cooking_time,
                        servings: recipe.servings,
                        instruction_steps: recipe.instruction_steps,
                        photo_url: recipe.photo_url,
                        ingredients: ingredients
                });
        }

        getDashRecipes() {
                this.connect();
                return this.HTTP.get('/latest-recipes');
        }

        getCustomRecipes() {
                this.connect();
                return this.HTTP.get('me/food/custom/recipes');
        }

        deleteRecipe(id) {
                this.connect();
                return this.HTTP.get('me/food/custom/recipes/delete/' + id);
        }

        prepareCheckout() {
                this.connect();
                return this.HTTP.post('me/checkout', {
                        amount: 35
                });
        }

        confirmPayment(paymentId) {
                this.connect();
                return this.HTTP.post('me/confirm-payment', {
                        paymentid: paymentId
                });
        }

        addFoodToFavourites(ingredientId) {
                this.connect();
                return this.HTTP.post('me/favourites/ingredients/new', {
                        ingredient_id: ingredientId
                });
        }

        removeFoodFromFavourites(ingredientId) {
                this.connect();
                return this.HTTP.post('me/favourites/ingredients/remove', {
                        ingredient_id: ingredientId
                });
        }

        addRecipeToFavourites(recipeId) {
                this.connect();
                return this.HTTP.post('me/favourites/recipes/new', {
                        recipe_id: recipeId
                });
        }

        removeRecipeFromFavourites(recipeId) {
                this.connect();
                return this.HTTP.post('me/favourites/recipes/remove', {
                        recipe_id: recipeId
                });
        }

        getFavouriteIngredients() {
                this.connect();
                return this.HTTP.get('me/favourites/ingredients');
        }

        getFavouriteRecipes() {
                this.connect();
                return this.HTTP.get('me/favourites/recipes');
        }

        recommendedIntakeCalculation(profile) {
                this.connect();
                return this.HTTP.post('me/update', {
                        profile: profile
                });
        }

        addDayToShopping(date) {
                this.connect();
                return this.HTTP.post('me/shopping/day/' + date.formatMYSQL());
        }
};

Date.prototype.formatMYSQL = function () {
        return this.getFullYear() + "-" + pad((this.getMonth() + 1), 2) + "-" + pad(this.getDate(), 2);
}

function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
}


// WEBPACK FOOTER //
// ./src/services/api.js